module.exports = __webpack_public_path__ + "static/img/MV12.ab8f1e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotografias/MV12.jpg
// module id = MX/5
// module chunks = 0